import { render, staticRenderFns } from "./step-5-specs.vue?vue&type=template&id=4cf01f8a&scoped=true&"
import script from "./step-5-specs.vue?vue&type=script&lang=js&"
export * from "./step-5-specs.vue?vue&type=script&lang=js&"
import style0 from "./step-5-specs.vue?vue&type=style&index=0&id=4cf01f8a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cf01f8a",
  null
  
)

export default component.exports